var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Knowledge_Base_-_Blue",
    "data-name": "Knowledge Base - Blue",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "learning",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-2",
    d: "M272.352,422A1.353,1.353,0,0,0,271,423.352a2.248,2.248,0,0,1,1.352-.451h5.888V422Z",
    transform: "translate(-262.858 -409.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-2",
    d: "M5.888,40.875a2.255,2.255,0,0,1,.448.045,3.145,3.145,0,0,0-2.25-.946H.9V30H0V40.875Z",
    transform: "translate(0 -29.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-2",
    d: "M274.854,482a1.354,1.354,0,0,0-1.274.9h7.163V482Z",
    transform: "translate(-265.361 -467.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-2",
    d: "M5.888,482H0v.9H7.163A1.354,1.354,0,0,0,5.888,482Z",
    transform: "translate(0 -467.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-2",
    d: "M5.888,422.9a2.242,2.242,0,0,1,1.352.452A1.354,1.354,0,0,0,5.888,422H0v.9Z",
    transform: "translate(0 -409.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-2",
    d: "M306.534,39.974h-3.185a3.145,3.145,0,0,0-2.25.946,2.255,2.255,0,0,1,.448-.045h5.888V30h-.9Z",
    transform: "translate(-292.053 -29.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-2",
    d: "M65.438,3.154A3.158,3.158,0,0,0,62.283,0H60V9.974h2.283a4.05,4.05,0,0,1,3.154,1.51Z",
    transform: "translate(-58.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-2",
    d: "M271,3.154v8.329a4.05,4.05,0,0,1,3.154-1.509h2.283V0h-2.283A3.158,3.158,0,0,0,271,3.154Z",
    transform: "translate(-262.858)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.a1126e39ee2754d16eb440c2970b715d.svg";
export { ForwardRef as ReactComponent };